import { render, staticRenderFns } from "./BodyTop.vue?vue&type=template&id=27808064&"
import script from "./BodyTop.vue?vue&type=script&lang=js&"
export * from "./BodyTop.vue?vue&type=script&lang=js&"
import style0 from "./BodyTop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports